import { StyleSheet } from 'react-native';
import { fontFamilyBold, fontSizeLarge } from '../../../constants/palette';

export default StyleSheet.create({
  container: {
    marginBottom: 2.5,
    marginTop: 2.5,
  },
  text: {
    fontFamily: fontFamilyBold, // Needs to be this after we get the font files
    fontSize: fontSizeLarge,
  },
});
